import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { IMAGES, VIDEO_URL } from "../../lib/constants";

export const VideoSection = () => (
  <section className="bg-[#0A0A0A] py-24 lg:py-32 px-6" data-testid="video-section">
    <div className="max-w-6xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10"
      >
        <div>
          <p className="text-xs tracking-[0.3em] font-bold text-[#E60000] mb-3">DIGGY SHOP EM MOVIMENTO</p>
          <h2 className="font-display font-bold text-4xl md:text-5xl text-white leading-none">O estúdio por dentro</h2>
        </div>
        <p className="text-sm text-white/50 max-w-xs font-light">
          Bastidores, arte e quase três décadas de história em Jundiaí.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.97 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="relative aspect-video border border-white/10 bg-[#171717] overflow-hidden group"
        data-testid="institutional-video-frame"
      >
        {VIDEO_URL ? (
          <video src={VIDEO_URL} autoPlay muted loop playsInline controls poster={IMAGES.videoPoster} className="w-full h-full object-cover" data-testid="institutional-video" />
        ) : (
          <>
            <img src={IMAGES.videoPoster} alt="Vídeo institucional Diggy Shop" className="absolute inset-0 w-full h-full object-cover opacity-40 grayscale group-hover:opacity-50 group-hover:scale-[1.03] transition-[opacity,transform] duration-700" />
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-6">
              <div className="w-20 h-20 rounded-full bg-[#E60000] flex items-center justify-center group-hover:scale-110 transition-transform duration-500 shadow-[0_0_60px_rgba(230,0,0,0.4)]">
                <Play size={28} className="text-white ml-1" fill="white" />
              </div>
              <div className="text-center">
                <p className="text-xs tracking-[0.4em] font-bold text-white">VÍDEO INSTITUCIONAL</p>
                <p className="text-xs tracking-[0.2em] text-white/50 mt-2">ESPAÇO RESERVADO • 16:9</p>
              </div>
            </div>
          </>
        )}
      </motion.div>
    </div>
  </section>
);
